import { React, useState } from "react";
import swal from "sweetalert";
import is_null from "./ObjectCheck";

const Signer = (props) => {
  const openModal = props.open;
  // const key = props.uniqueKey;
  const left = props.left ? props.left : 0;
  const lang = props.lang;
  const top = props.top ? props.top : 0;
  const imageUrl = props.imageUrl;
  const index = props.index;
  const fields = props.fields;
  const topText = props.topText;
  const id = props.id ? props.id : "noidgoaway";
  const size = props.size === "smaller" ? "initialsImage" : "signatureImage";
  const canSubmit = props.canSubmit;
  const submit = props.submit;
  const showModal = props.showModal;
  const width = props.width;
  const height = props.height;
  const setImageUrl = props.setImageUrl;

  // const docsClickedOnceList = props.docsClickedOnceList;
  const isnull = is_null(imageUrl);
  // const clickedOnce =
  //   docsClickedOnceList.current[props.index].clicked && !isnull;
  const clickedOnce = props.clicked;
  const setClicked = props.setClicked;
  const zoom = props.zoom;
  const zoomScaled = zoom / 100;
  // const canSubmit = props.canSubmit;
  // const submitList = props.submitList;

  const [opacity, setOpacity] = useState(90);

  const positionID = {
    position: "absolute",
    left: "50%",
    top: `${-window.innerHeight / 2 / (zoom / 100)}px`,
    zIndex: 1,
  };

  //used to position the button used to click where to sign the documents
  const locationCss = (left, top) => {
    // let changeHue =
    //   !isnull && clickedOnce ? "hue-rotate(0deg)" : "hue-rotate(0deg)";

    const l = left;
    const b = top;

    return {
      position: `absolute`,
      transform: `translate(0%, 50%)`,
      opacity: `${opacity / 100}`,
      zIndex: "2",
      left: `${l}%`,
      bottom: `${b}%`,
      // filter: `${changeHue}`,
    };
  };

  //used to position the button used to click where to sign the documents
  const textboxCss = (left, top, width, height) => {
    // let changeHue =
    //   !isnull && clickedOnce ? "hue-rotate(0deg)" : "hue-rotate(0deg)";

    const l = left;
    const b = top;

    return {
      position: `absolute`,
      opacity: `${opacity / 100}`,
      transform: "translate(0%, 0%)",
      zIndex: "2",
      left: `${l}%`,
      margin: "5px",
      bottom: `calc(${b}%)`,
      width: `${width * zoomScaled}%`,
      height: `${height * zoomScaled}%`,
    };
  };

  // hide the button if you clicked the
  // sign location AND there is an image signed for that key
  const is_hidden = !isnull && clickedOnce ? "hide" : "pointer";

  return !showModal ? (
    <div title={`${id}`} style={textboxCss(left, top, width, height)}>
      <textarea
        onChange={(t) => {
          setClicked(index);
          setImageUrl(t.target.value);
        }}
        style={{
          width: "100%",
          height: "100%",
          padding: "0px",
          minHeight: "32px",
          fontSize: "14px",
        }}
      ></textarea>
    </div>
  ) : (
    <div
      title={`${id}`}
      style={locationCss(left, top)}
      onMouseEnter={() => {
        setOpacity(25);
      }}
      onMouseLeave={() => {
        setOpacity(80);
      }}
    >
      <IconSrc
        text={topText}
        className={is_hidden}
        onClick={() => {
          setClicked(index); // sets this location to be clicked

          if (isnull && showModal) {
            document.location.hash = `loc${id}`;
            openModal(true);
          } else {
            // this finds the next lowest id that hasnt been clicked
            // the keys of clickSpots is the id of the sign location
            // so we return the key as the next id
            let max_id = props.maxId;
            let next_id = props.getNextId(fields);
            if (next_id !== max_id && next_id > -1) {
              document.location.hash = `loc${Number(next_id) + 1}`;
            }

            if (!canSubmit(fields)) {
              return;
            }

            swal({
              title: lang.AllGoodToSubmit,
              text: lang.AllLocations,
              buttons: {
                cancel: lang.GoBack,
                submit: {
                  text: lang.Submit,
                  value: "submit",
                },
              },
              icon: "success",
            }).then((res) => {
              if (res === "submit") {
                submit();
              }
            });
          }
        }}
      />
      <div style={positionID} id={`loc${id}`}></div>
      {!isnull && clickedOnce ? (
        <img
          className={`signatureOffset signatureOverlay positionabs ${size} ${
            clickedOnce ? "pointer" : "nopointer"
          }`}
          height="40"
          width={"auto"}
          src={imageUrl}
          alt=""
          onClick={() => {
            if (showModal) {
              openModal(true);
              document.location.hash = " ";
            }
          }}
        />
      ) : (
        blank()
      )}
    </div>
  );
};
export default Signer;

const blank = () => {
  return (
    <img
      src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D"
      width="0"
      height="0"
      alt=""
    />
  );
};

const IconSrc = (props) => {
  return (
    <svg
      width={"60"}
      height={"60"}
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        width: "60",
        height: "60",
        border: "0px solid transparent",
        borderRadius: "7px",
        boxShadow: "3px 3px 10px rgba(1, 1, 1, 0.5)",
      }}
      {...props}
    >
      <path
        d="M50 4.869A4.872 4.872 0 0 0 45.131 0H4.869A4.872 4.872 0 0 0 0 4.869v40.262A4.872 4.872 0 0 0 4.869 50h40.262A4.872 4.872 0 0 0 50 45.131V4.869Z"
        style={{
          fill: "#ffde79",
          fillOpacity: 0.5,
        }}
        transform="matrix(.96 0 0 .96 1 1)"
      />
      <path
        d="M50 5.434A5.437 5.437 0 0 0 44.566 0H5.434A5.437 5.437 0 0 0 0 5.434v39.132A5.437 5.437 0 0 0 5.434 50h39.132A5.437 5.437 0 0 0 50 44.566V5.434Zm-1 .241A4.677 4.677 0 0 0 44.325 1H5.675A4.677 4.677 0 0 0 1 5.675v38.65A4.677 4.677 0 0 0 5.675 49h38.65A4.677 4.677 0 0 0 49 44.325V5.675Z"
        style={{
          fill: "#c09326",
        }}
      />
      <text
        x={35}
        y={21.798}
        textAnchor="middle"
        style={{
          fontFamily: "'ArialMT','Arial',sans-serif",
          fontSize: 12,
        }}
        transform="translate(-10 -5)"
      >
        {props.text}
      </text>
      <path d="M41.5 44a1 1 0 0 0-1-1h-31a1 1 0 0 0 0 2h31a1 1 0 0 0 1-1ZM16.283 32.874l8.093 8.093a1.99 1.99 0 0 0 .73 0l8.611-8.611a2.501 2.501 0 0 0-4.262-1.606l-2.714 2.714V25a2 2 0 0 0-4 0v8.464l-2.196-2.196a2.501 2.501 0 0 0-4.262 1.606Z" />
    </svg>
  );
};

// const checkModalErrors = (modals, lang) => {
//   let error_count = 0;

//   // We check the modals for signatures
//   for (let i = 0; i < modals.length; i++) {
//     const m = modals[i];
//     if (is_null(m.props.getImageURL.current) && m.props.needed) {
//       if (m.props.type == "signature") {
//         swal({
//           title: lang.MissingSignature,
//           text: lang.LookOver,
//           button: lang.Ok,
//           icon: "warning",
//         });
//       } else if (m.props.type == "initial") {
//         swal({
//           title: lang.MissingInitial,
//           text: lang.LookOver,
//           button: lang.Ok,
//           icon: "warning",
//         });
//       } else {
//         swal({
//           title: lang.MissingLocation,
//           text: lang.LookOver,
//           button: lang.Ok,
//           icon: "warning",
//         });
//       }
//       error_count += 1;
//       return false;
//     }
//   }
//   return true;
// };
